import { useQuery } from "@tanstack/react-query"
import { listFundCapitalCalls, listFundDistributions } from "@/api/irr"
import { FundCapitalCall, FundDistribution } from "@/types"

export const useFundCapitalCalls = (fundId: number | null) => {
  return useQuery<FundCapitalCall[]>({
    queryKey: ["fundCapitalCalls", fundId],
    queryFn: () => listFundCapitalCalls(fundId!),
    enabled: !!fundId,
    staleTime: 1000 * 60 * 5,
  })
}

export const useFundDistributions = (fundId: number | null) => {
  return useQuery<FundDistribution[]>({
    queryKey: ["fundDistributions", fundId],
    queryFn: () => listFundDistributions(fundId!),
    enabled: !!fundId,
    staleTime: 1000 * 60 * 5,
  })
}
